import { useEffect, useState } from "react";
import { MDBInputGroup,
    MDBAccordion, MDBAccordionItem, MDBIcon,
} from 'mdb-react-ui-kit';
import CustomModal from "../components/CustomModal";
import { fetchData, getProductImage } from "../function/util";
import {
  Elements, AddressElement, LinkAuthenticationElement,
} from '@stripe/react-stripe-js';
import StripeCheckout from "../components/StripeCheckout";
import {loadStripe} from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const Checkout=()=>{
    const [data, setData] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [clientSecret, setClientSecret] = useState(null);
    const [activeItem, setActiveItem] = useState(1);
    const [summaryTotal, setSummaryTotal] = useState({});
    const [address, setAddress] = useState(null);
    const [email, setEmail] = useState(null);
    const [promoCode, setPromoCode] = useState(null);
    const [promoCodeTitle, setPromoCodeTitle] = useState(null);
    const [hidePromo, setHidePromo] = useState(false);

    useEffect(() => {
        const cart = JSON.parse(localStorage.getItem("cart") ?? '[]');
        setData(cart);
    }, []);

    useEffect(()=>{
        const subTotal = data.reduce((acc, item) =>
            acc + (parseFloat(item.quantity) * parseFloat(item.sku.price)),
            0
        );
        const shippingFee = subTotal >= 50 ? 0 : 5;
        const taxRate = subTotal * 0.08;
        setSummaryTotal({
            subTotal: parseFloat(subTotal),
            estimatedTax: parseFloat(taxRate),
            total: parseFloat(subTotal + taxRate + shippingFee),
            shipping: shippingFee
        });
    }, [data]);

    useEffect(() => {
        if (!email || !address) return;
        const customer = {
            email,
            name: address.name,
            // phone: address.phone,
            address: address.address,
        };

        const simpleCart = data.map(item => ({
            name: item.name,
            quantity: item.quantity,
            sku: item.sku
        }));

        const cartData = {
            cart: simpleCart,
            customer,
            promo: promoCode
        };
        (async () => {
            const res = await fetchData("paymentIntent", {cartData});
            const { orderId, intentSecret, subTotal, taxRate, shippingFee, total, promoCodeInfo } = res;
            if(!intentSecret)return;
            setHidePromo(true);
            localStorage.setItem("orderId", orderId);
            setPromoCodeTitle(promoCodeInfo);

            setSummaryTotal({
                estimatedTax: null,
                subTotal,
                tax: parseFloat(taxRate),
                total,
                shipping: shippingFee
            });
            setClientSecret(intentSecret);
            setActiveItem(2);
        })();
    }, [email, address, data, promoCode]);

    const showCart=(item)=>{
        setSelectedItem(item);
        setShowModal(true);
    }

    const getDiscount=async()=>{
        if(!promoCode)return;
        const res = await fetchData("discount", {code: promoCode});
        const discount = res.discount[0];
        if(discount===undefined){
            setPromoCodeTitle("Invalid Discount Code");
            return;
        }
        setPromoCodeTitle("Discount Applied: " + discount.title);
        applyDiscount(discount);
    }

    const applyDiscount=(discount)=>{
        const summary = summaryTotal;
        let taxRate = 0;
        switch (discount.type.toLowerCase()) {
            case "free shipping":
                summary.shipping = 0;
                summary.total = summary.subTotal;
                break;

            default:
                const subtotal = summary.subTotal - (summary.subTotal * (discount.value/100));
                taxRate = subtotal * 0.08;
                summary.subTotal = subtotal;
                break;
        }
        summary.estimatedTax = parseFloat(taxRate);
        summary.total = parseFloat(summary.subTotal + taxRate + summary.shipping);
        setSummaryTotal(summary);
    }

    if(showModal){
        return <CustomModal dItem={selectedItem} deleteItem={true}/>
    }

    return (
    <div className="main-content container" style={{color: "#333", backgroundColor: "#eee"}}>
        <div className="d-flex justify-content-between m-2 pt-3">
            <h2 className="headerColor">Checkout</h2>
            <p className="fw-bold">Order Total: ${summaryTotal.total}</p>
        </div>
        <div className="row">
            <div className="col col-lg-4">
                <div style={{backgroundColor:"#fff", padding: "10px", height: "100vh"}}>
                    <h4 className="headerColor">Summary</h4>
                    {!hidePromo&&<MDBInputGroup className='mb-3' textAfter={<MDBIcon style={{cursor: "pointer"}} onClick={()=>getDiscount()} fas icon="arrow-right" />}>
                        <input className='form-control' defaultValue={promoCode} onChange={(e)=>setPromoCode(e.target.value)} type='text' placeholder='Promo code' />
                    </MDBInputGroup>}
                    <span style={{fontSize: "9px", color:"red"}}>{promoCodeTitle}</span>
                    <div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>Subtotal</td>
                                    <td>${parseFloat(summaryTotal.subTotal).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Shipping</td>
                                    <td>${parseFloat(summaryTotal.shipping).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>{summaryTotal.estimatedTax!=null&&"Estimated "}Tax</td>
                                    <td>${summaryTotal.estimatedTax!=null ? parseFloat(summaryTotal.estimatedTax).toFixed(2):parseFloat(summaryTotal.tax).toFixed(2)}</td>
                                </tr>
                                <tr style={{fontWeight: "bolder"}}>
                                    <td>Total</td>
                                    <td>${parseFloat(summaryTotal.total).toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="fw-bold">{`Cart (${data.length}) Items`}</p>
                    <div style={{overflowY: "scroll", height: "300px"}}>
                    {data.map((d, i)=>(
                        <div key={i}>
                            <div className="d-flex justify-content-between">
                                <img src={getProductImage(d)} width={40} height={40} alt={d.name} />
                                <div>
                                    <p>{d.name.trim()}</p>
                                    <p>Quantity: {d.quantity}</p>
                                    <MDBIcon style={{cursor: "pointer"}} color="danger" fas icon='trash' size='lg' onClick={()=>showCart(d)} />
                                </div>
                                <div>
                                    ${parseFloat(d.sku.price * d.quantity).toFixed(2)}
                                </div>
                            </div>
                            <hr />
                        </div>
                    ))}</div>
                    <hr />
                </div>
            </div>
            <div className="col col-lg-8">
                <div className="w-100" style={{ overflowY: "auto", backgroundColor: "#fff", height: "88vh"}}>
                    <MDBAccordion onChange={(e)=>setActiveItem(e)} initialActive={1} active={activeItem}>
                        <MDBAccordionItem collapseId={1} headerTitle={<b>Shipping</b>}>
                            <Elements stripe={stripePromise} options={{
                                amount: 1099, mode: "payment", currency: "usd", payment_method_types: ['card']
                            }}>
                                <LinkAuthenticationElement
                                    onChange={(event) => {
                                        if (event.complete) {
                                            setEmail(event.value.email);
                                        }
                                    }}
                                />
                                <AddressElement
                                    options={{
                                        mode: 'shipping', allowedCountries: ['US'],
                                    }}
                                    onChange={(event) => {
                                        if (event.complete) {
                                            setAddress(event.value);
                                        }
                                    }}
                                />
                            </Elements>
                        </MDBAccordionItem>
                        <MDBAccordionItem collapseId={2} headerTitle={<b>Payment</b>}>
                            {clientSecret&&<StripeCheckout
                                stripePromise={stripePromise}
                                clientSecret={clientSecret}
                            />}
                        </MDBAccordionItem>
                    </MDBAccordion>
                </div>
            </div>
        </div>
    </div>
  );
}
export default Checkout;